<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>
      Activated Processes
    </li>
  
  </ul>
  <div class="container-fluid px-4">
    <section class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <span class="cat__core__title">
          <strong>Activated Processes</strong>
        </span>
      </div>
  
      <section class="card search-box">
        <div class="card-header d-flex justify-content-between align-items-center" (click)="toggleSearchDiv()" style="cursor: pointer;">
          <span>Modify Search</span>
          <i class="fa fa-filter" aria-hidden="true"></i>
        </div>
        <div class="card-block" [ngClass]="{'d-none': !isSearchDivVisible}">
          <div class="row">
            <div class="col-md-12">
              <form>
                <div class="row activated-process-filter-row">
                  <div class="col-md-3">
                    <label class="form-control-label">User defined / Pre defined</label>
                    <div class="form-group">
                      <div class="radio-options-group-process">
                        <div class="md-radio md-radio-inline">
                          <input id="IsPreDefined" type="radio" name="IsPredefinedorUserdefined" 
                            [(ngModel)]="SearchprocessUserdefinedorPredefinedModel" 
                            [ngModelOptions]="{standalone: true}" 
                            value="Predefined" 
                            (click)="CheckProcessType('Predefined')"
                            class="form-check-input">
                          <label for="IsPreDefined">Pre defined</label>
                        </div>
                        <div class="md-radio md-radio-inline">
                          <input id="IsUserDefined" type="radio" name="IsPredefinedorUserdefined" 
                            [(ngModel)]="SearchprocessUserdefinedorPredefinedModel" 
                            [ngModelOptions]="{standalone: true}" 
                            value="Userdefined" 
                            (click)="CheckProcessType('Userdefined')"
                            class="form-check-input">
                          <label for="IsUserDefined">User defined</label>
                        </div>
                      </div>
                    </div>
                  </div>
  
                  <div class="col-md-6">
                    <label class="form-control-label">Meetings Date Range:</label>
                    <div class="form-group">
                      <div class="input-group date-range-group-process">
                        <span class="date-range-label">From:&nbsp;</span>
                        <div class="date-input-wrapper">
                          <input class="form-control" [(ngModel)]="activatedTaskSearchDateFrom" 
                            placeholder="dd-mm-yyyy" ngbDatepicker #c="ngbDatepicker" 
                            (focus)="c.toggle();r.close();" (document:click)="c.close();" 
                            (ngModelChange)="activatedTaskSearchFromDuedateChange()"
                            [ngModelOptions]="{standalone: true}">
                          <button class="input-group-addon" (click)="c.toggle();r.close();" type="button">
                            <i class="fa fa-calendar"></i>
                          </button>
                        </div>
                        <span class="date-range-label">&nbsp;&nbsp;To:&nbsp;</span>
                        <div class="date-input-wrapper">
                          <input class="form-control" [(ngModel)]="activatedTaskSearchDateTo" 
                            placeholder="dd-mm-yyyy" ngbDatepicker #r="ngbDatepicker" 
                            (focus)="r.toggle();c.close();" (document:click)="r.close();" 
                            [ngModelOptions]="{standalone: true}" [minDate]="minDateForSearchTo">
                          <button class="input-group-addon" (click)="r.toggle();c.close();" type="button">
                            <i class="fa fa-calendar"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
  
                  <div class="col-md-3">
                    <label class="form-control-label">&nbsp;</label>
                    <div class="form-group filter-actions-process">
                      <button type="button" [disabled]="response" class="btn btn-sm btn-primary" 
                        title="search" (click)="showTasksBySearchData()">
                        <i class="fa fa-search"></i>&nbsp;Search
                      </button>
                      <button type="button" [disabled]="response" class="btn btn-sm btn-default btn-clear" 
                        (click)="showAllProcesses()" title="refresh">
                        <i class="fa fa-refresh"></i>&nbsp;Clear
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
  
      <div class="card-block datatable-card-block">
        <div class="table-responsive" style="position: relative;">
          <!-- Loader overlay for Activated Process List -->
          <div class="activated-process-loader-overlay" *ngIf="isLoading">
            <div class="activated-process-loader-container">
              <img src="assets/images/DigiCompany_loader.png" class="activated-process-spinner" alt="Loading..." />
            </div>
          </div>
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" 
            class="table table-hover" id="processTable">
            <thead>
              <tr>
                <th>Process Name</th>
                <th>Task Particulars</th>
                <th>Global/Company Specific</th>
                <th>Meeting Type</th>
                <th class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let process of processes; let count=index">
                <td>{{process.ProcessName}}</td>
                <td>{{process.TaskParticulars}}</td>
                <td>
                  <span *ngIf="process.IsGlobal">Global</span>
                  <span *ngIf="process.IsGlobal===false">Company Specific</span>
                </td>
                <td>
                  <span *ngIf="process.IsMeetingTask && process.MeetingTypeId!=null">{{process.MeetingType}}</span>
                  <span *ngIf="process.MeetingTypeId==null">N/A</span>
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-warning btn-sm" (click)="showProcessTasks(process._id)">
                    Show Tasks
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
  <app-alert></app-alert>